import { useEffect, useState } from 'react'
import { FaFilePdf } from 'react-icons/fa6'
import { RiShoppingCart2Line } from "react-icons/ri"
import { toast } from 'react-toastify'
import { useNavigate } from 'react-router-dom'
import { RxCross2 } from "react-icons/rx";
import { useCart } from '../../../../Providers/CartProvider'
import { useAuth } from '../../../../Providers/AuthProvider'
import { useOffers } from '../../../../Providers/OffersProvider'
import YesNoCancelMessageModal from '../../../../Components/Components/Modals/YesNoCancelMessageModal'
import { ConvertPriceToString } from '../../../../Helpers/CustomConverter'
import LoadingSpinner from '../../../../Components/Components/LoadingSpinner'
import OfferItems from './OfferItems'
import { OfferCurrentView } from '../../../../Data/PageModeEnums.ts'
import InformationErrorModal from '../../../../Components/Components/Modals/InformationErrorModal.jsx'
import { FaRegEye } from 'react-icons/fa6';
import { OverlayTrigger, Popover } from "react-bootstrap";

import 'react-icons'

const Offer = ({ offer, currentView, handleCreateOfferRequest, handleCreateRetailerOffer, handleDeleteRetailerOfferFunc, handleDownloadPdf, isDownloadingPdf,
    setIsLoadingBasket, lastBookElementRef, handleEditOffer }) => {
    const { authState } = useAuth()
    const { addProductsToBasket, cartItems } = useCart()
    const { handleGetRequestOfferItems, handleGetRetailerOfferItems, handleGetCustomerOfferItems } = useOffers()
    const [offerItems, setOfferItems] = useState([])
    const [showItems, setShowItems] = useState(false)
    const [isLoadingItems, setIsLoadingItems] = useState(false)
    const [showQuestionAboutReplaceBasket, setShowQuestionAboutReplaceBasket] = useState(false)
    const navigate = useNavigate()
    const [realizeOfferModalObj, setRealizeOfferModalObj] = useState({ show: false, message: '', offerItems: [] })
    const [isDownloadingOfferItems, setIsDownloadingOfferItems] = useState(false)

    function reverseDate(date) {
        try {
            const [year, month, day] = date.split('-')
            return `${day}-${month}-${year}`
        } catch {
            return ''
        }

    }

    useEffect(() => {
        if (showItems) {
            handleGetItems()
        }
    }, [showItems])

    const handleGetItems = async () => {
        setIsLoadingItems(true)
        var items = [];
        switch (currentView) {
            case OfferCurrentView.OfferCustomer:
                items = await handleGetCustomerOfferItems(offer.offerNo, offer.offerSiteId)
                break;
            case OfferCurrentView.OfferRetailer:
                items = await handleGetRetailerOfferItems(offer.offerNo, offer.offerSiteId)
                break;
            case OfferCurrentView.OfferRequest:
                items = await handleGetRequestOfferItems(offer.offerNo, offer.offerSiteId)
                break;
        }
        setOfferItems(items)
        setIsLoadingItems(false)
    }

    const handleLoadCustomerOffer = async () => {
        if (!authState.user) {
            toast.warning('Prosze się zalogować')
            return
        }
        if (!authState.custId) {
            toast.warning('Brak wybranego kontrahenta')
            return
        }
        setIsDownloadingOfferItems(true)
        const now = new Date()
        const expiredOfferDate = new Date(offer.expirationDate)
        const nowToCompare = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        const expiredToCompare = new Date(expiredOfferDate.getFullYear(), expiredOfferDate.getMonth(), expiredOfferDate.getDate());
        let items = await handleGetCustomerOfferItems(offer.offerNo, offer.offerSiteId)

        let tmpItems = items.map(item => ({
            ...item,
            qty: item.qty - item.orderQty
        })).filter(item => item.qty > 0) // Odejmujemy ilości zamówione i w razie gdy jest 0 to je usuwamy    

        setIsDownloadingOfferItems(false)
        if (expiredToCompare < nowToCompare) {
            setRealizeOfferModalObj({
                show: true,
                message: 'Oferta jest przeterminowana, nie można jej zrealizować!\n Zostanie utworzony nowy koszyk z pozycjami z oferty.\n Ceny zostaną przeliczone zgodnie z cennikiem!',
                offerItems: items
            })
            return
        }
        else if (tmpItems.length === 0) {
            setRealizeOfferModalObj({
                show: true,
                message: 'Oferta została już całkowicie zamówiona / zrealizowana!\n Zostanie utworzony nowy koszyk z pozycjami z oferty.\n Ceny zostaną przeliczone zgodnie z cennikiem!',
                offerItems: items
            })
            return
        }
        else {
            window.location.href = `/Cart?custId=${authState.custId}&offerNo=${offer.offerNo}&offerSiteId=${offer.offerSiteId}`
        }
    }

    const handleLoadRetailerOffer = async () => {
        if (!authState.user) {
            toast.warning('Prosze się zalogować')
            return
        }
        if (!authState.custId) {
            toast.warning('Brak wybranego kontrahenta')
            return
        }
        if (cartItems && cartItems.basketItems && cartItems.basketItems.length > 0) {
            setShowQuestionAboutReplaceBasket(true)
        } else {
            handleAddItemsToCart(false)
        }
    }

    const handleRealizeOfferModalClose = async () => {
        if (cartItems && cartItems.basketItems && cartItems.basketItems.length > 0) {
            setShowQuestionAboutReplaceBasket(true)
        }
        else {
            setIsLoadingBasket(true)
            await addProductsToBasket(realizeOfferModalObj.offerItems, true)
            setIsLoadingBasket(false)
            navigate('/Cart')
        }
        setRealizeOfferModalObj(prev => ({
            show: false,
            message: '',
            offerItems: prev.offerItems,
        }))
    }

    // const handleAddSelectedOfferToBasket = () => {
    //     if (!authState.user) {
    //         toast.warning('Prosze się zalogować')
    //         return
    //     }
    //     if (!authState.custId) {
    //         toast.warning('Brak wybranego kontrahenta')
    //         return
    //     }
    //     if (cartItems && cartItems.basketItems && cartItems.basketItems.length > 0) {
    //         setShowQuestionAboutReplaceBasket(true)
    //     } else {
    //         handleAddItemsToCart(false)
    //     }
    // }

    const handleMessageModalResult = (answer) => {
        setShowQuestionAboutReplaceBasket(false)
        if (answer === 'Cancel') {
            return
        }
        var replaceBasket = answer === 'Yes' ? true : false
        handleAddItemsToCart(replaceBasket)
    }

    const handleAddItemsToCart = async (replaceBasket) => {
        setIsLoadingBasket(true)
        //let items = []   
        // if (currentView === OfferCurrentView.OfferCustomer) {
        //     items = await handleGetCustomerOfferItems(offer.offerNo, offer.offerSiteId)
        // }
        // else if (currentView === OfferCurrentView.OfferRetailer) {
        //     items = await handleGetRetailerOfferItems(offer.offerNo, offer.offerSiteId)
        // }              
        if (realizeOfferModalObj.offerItems && realizeOfferModalObj.offerItems.length > 0) {
            await addProductsToBasket(realizeOfferModalObj.offerItems, replaceBasket)
            setRealizeOfferModalObj({ show: false, message: '', offerItems: [] })
        }
        else {
            let items = await handleGetRetailerOfferItems(offer.offerNo, offer.offerSiteId)
            await addProductsToBasket(items.filter(i => i.externalArticle === false), replaceBasket)
        }
        setIsLoadingBasket(false)
        navigate('/Cart')
    }

    const generateDateSection = () => {
        if (currentView === OfferCurrentView.OfferRequest) {
            return (
                <td style={{ alignContent: "center", verticalAlign: 'middle', fontSize: '14px' }} onClick={() => setShowItems(!showItems)}>
                    <span style={{ fontWeight: "bold" }}>{offer.createDate ? reverseDate(offer.createDate.substring(0, offer.createDate.indexOf('T'))) : ''}</span>
                </td>
            )
        }
        else if (currentView === OfferCurrentView.OfferRetailer) {
            return (
                <td style={{ alignContent: "center", verticalAlign: 'middle', fontSize: '14px' }} onClick={() => setShowItems(!showItems)}>
                    <span style={{ fontWeight: "bold" }}>{offer.expirationDate ? reverseDate(offer.expirationDate.substring(0, offer.expirationDate.indexOf('T'))) : ''}</span>
                </td>
            )
        }
        else {
            return (
                <td style={{ alignContent: "center", verticalAlign: 'middle', fontSize: '14px' }} onClick={() => setShowItems(!showItems)}>
                    {offer.offerDate ? reverseDate(offer.offerDate.substring(0, offer.offerDate.indexOf('T'))) : ''}<br />
                    <span style={{ fontWeight: "bold" }}>{offer.expirationDate ? reverseDate(offer.expirationDate.substring(0, offer.expirationDate.indexOf('T'))) : ''}</span>
                </td>
            )
        }
    }

    const getOfferNumberToShow = () => {
        if (currentView === OfferCurrentView.OfferRequest) {
            if (authState.user && authState.user.isOperator) {
                return offer.offerNo
            }
            else {
                return offer.orginalOfferNo
            }
        }
        else {
            return offer.offerNo
        }
    }

    const handleShowResponseForOfferRequest = () => {
        navigate(`/OfferDetails/${offer.orginalOfferNo}/${offer.offerSiteId}`)
    }

    const popoverShowResponse = <Popover id="popover-basic">
        <Popover.Body className="text-center">
            <span className='primary-accent-color-text'>Zobacz odpowiedź do zapytania - ofertę</span>
        </Popover.Body>
    </Popover>

    return (<>
        <InformationErrorModal
            show={realizeOfferModalObj.show}
            setShow={handleRealizeOfferModalClose}
            title={"UWAGA"}
            message={realizeOfferModalObj.message}
            isError={true}
            isVersionControlInformation={false}
            showCloseButton={false}
        />
        <YesNoCancelMessageModal
            show={showQuestionAboutReplaceBasket}
            onHide={handleMessageModalResult}
            title={'Pytanie'}
            message={'Twój koszyka zawiera już pozycje, co chcesz zrobić z zaznaczonymi pozycjami, które dodajesz do koszyka?'}
            yesText='Nadpisz koszyk'
            noText='Dopisz do koszyka'
        />
        <tr ref={lastBookElementRef} className='hoverable-row'>
            <td style={{ alignContent: "center", verticalAlign: 'middle', fontSize: '14px' }} onClick={() => setShowItems(!showItems)}>
                {getOfferNumberToShow()}<br />
                <span style={{ fontWeight: "bold" }}>{offer.requestDate ? reverseDate(offer.requestDate.substring(0, offer.requestDate.indexOf('T'))) : ''}</span>
            </td>
            <td style={{ alignContent: "center", verticalAlign: 'middle', fontSize: '14px' }} onClick={() => setShowItems(!showItems)}>
                {currentView === OfferCurrentView.OfferRetailer ? offer.investor : offer.source}
            </td>
            {generateDateSection()}
            <td style={{ alignContent: "center", verticalAlign: 'middle', fontSize: '14px' }} onClick={() => setShowItems(!showItems)}>
                {offer.investmentName}
            </td>
            {currentView !== OfferCurrentView.OfferRetailer && <td style={{ alignContent: "center", verticalAlign: 'middle', fontSize: '14px' }} onClick={() => setShowItems(!showItems)}>
                {offer.status}
            </td>}
            <td style={{ alignContent: "center", verticalAlign: 'middle', fontSize: '14px', textAlign: 'right' }} onClick={() => setShowItems(!showItems)}>
                {ConvertPriceToString(offer.netValue, null)}<br />
                <span style={{ fontWeight: "bold" }}>{ConvertPriceToString(offer.grossValue, null)}</span>
            </td>
            {currentView !== OfferCurrentView.OfferRequest && <td style={{ textAlign: "center", verticalAlign: 'middle', fontSize: '14px', textAlign: 'right' }}>
                {isDownloadingPdf ? <LoadingSpinner height={2} width={2} bubble={false} /> : <FaFilePdf color='black' size={20} onClick={() => handleDownloadPdf(offer.offerNo, offer.offerSiteId)} />}
            </td>}
            {currentView === OfferCurrentView.OfferCustomer && <td style={{ textAlign: "center", verticalAlign: 'middle', fontSize: '14px', textAlign: 'right' }}>
                {isDownloadingOfferItems ? (<LoadingSpinner height={2} width={2} bubble={false} />) : (<RiShoppingCart2Line size={20} color='var(--primary)' onClick={handleLoadCustomerOffer} />)}
            </td>}
            {currentView === OfferCurrentView.OfferRetailer && <td style={{ textAlign: "center", verticalAlign: 'middle', fontSize: '14px', textAlign: 'right' }}>
                <RiShoppingCart2Line size={20} color='var(--primary)' onClick={handleLoadRetailerOffer} />
            </td>}
            {currentView === OfferCurrentView.OfferRetailer && <td style={{ textAlign: "center", verticalAlign: 'middle', fontSize: '14px', textAlign: 'right' }}>
                <RxCross2 size={20} color='var(--error-color)' onClick={() => handleDeleteRetailerOfferFunc(offer.offerNo, offer.offerSiteId)} />
            </td>}
            {currentView === OfferCurrentView.OfferRequest && offer.status == 'Oferta gotowa' &&
                <OverlayTrigger trigger={["hover", "focus"]} placement="bottom" overlay={popoverShowResponse}>
                    <td style={{ textAlign: "center", verticalAlign: 'middle', fontSize: '14px', textAlign: 'right' }} onClick={handleShowResponseForOfferRequest}>
                        <FaRegEye size={20} color='var(--primary)' />
                    </td>
                </OverlayTrigger>
            }
        </tr >
        {showItems && (
            <tr>
                <td colSpan='9' style={{ padding: 10 }}>
                    <OfferItems
                        items={offerItems}
                        isLoading={isLoadingItems}
                        currentView={currentView}
                        handleCreateOfferRequest={handleCreateOfferRequest}
                        handleCreateRetailerOffer={handleCreateRetailerOffer}
                        offerExpiredDate={offer.expirationDate}
                        offerNo={offer.offerNo}
                        handleEditOffer={handleEditOffer}
                        offerSiteId={offer.offerSiteId}
                    />
                </td>
            </tr>
        )}


    </>
    );
};

export default Offer;
